import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function () {
  let total_num = $('.section1 .right-list ul li').length
  let videoUrl = $('.section1 .right-list ul li').eq(0).attr('data-videourl')
  $('.section1 .right-list ul li').eq(0).addClass('active')
  $('.section1 .right-list .num .active-num').html(1)
  $('.section1 .right-list .num .total-num').html(total_num)

  setTimeout(function(){
    $('#video').attr('src',videoUrl)
    $('.left-video').find('video')[0].play()
  },100)
})

$('.section1 .right-list ul li').on('click',function(){
  let index = $(this).index()
  let videoUrl = $(this).attr('data-videourl')

  $(this).addClass('active').siblings().removeClass('active')
  $('.section1 .right-list .num .active-num').html(index+1)

  $('#video').attr('src',videoUrl)
  $('.left-video').find('video')[0].play()
})